module.exports = __webpack_public_path__ + "static/media/as-appsumo-logo-blk.18543264.png";